import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import bookingsApi from '@/features/dashboard/bookings/api/bookingsApi.ts';
import { bookingsApiQueryKeys } from '@/features/dashboard/bookings/api/bookingsApi.queryKeys.ts';
import { BookingBillDto } from '@/features/dashboard/bookings/types/BookingBillDto.ts';

/** Księga cen rezerwacji — kwoty wszystkich ekranów rachunku. */
const useGetBookingBill = (bookingId: string | undefined) =>
  useQuery(getBookingBillQueryOptions(bookingId));

export const getBookingBillQueryOptions = (
  bookingId: string | undefined,
): UseQueryOptions<BookingBillDto> => ({
  queryKey: bookingsApiQueryKeys.bill(bookingId ?? ''),
  queryFn: () => bookingsApi.getBill(bookingId!),
  enabled: !!bookingId,
  staleTime: 1000 * 60,
});

export default useGetBookingBill;
